import React from 'react';
import { PLAN_RANK } from '../data/mockData';
import { useApp } from '../context/AppContext';
import { ProductCard } from '../components/commerce/ProductCard';
import { StoreCard } from '../components/commerce/StoreCard';

function Row({ title, children, testId }) {
  return (
    <section data-testid={testId} className="mx-auto max-w-[1280px] px-4 py-6">
      <h2 className="mb-4 text-base md:text-lg font-semibold text-kelate-ink">{title}</h2>
      {children}
    </section>
  );
}

export default function MarketplacePage() {
  const { customMerchants, customProducts } = useApp();
  const grid = (items) => (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
      {items.map((p) => <ProductCard key={p.id} product={p} />)}
    </div>
  );
  const deals = customProducts.filter((p) => (p.badges || []).includes('SALE'));
  const best = [...customProducts].sort((a, b) => b.sold - a.sold).slice(0, 4);
  const fresh = customProducts.filter((p) => (p.badges || []).includes('NEW'));
  const localPicks = customProducts.filter((p) => p.madeInKelantan).slice(0, 4);
  const featured = customProducts.filter((p) => (p.badges || []).includes('FEATURED'));
  return (
    <div data-testid="marketplace-page">
      <div className="border-b border-kelate-line bg-kelate-surface">
        <div className="mx-auto max-w-[1280px] px-4 py-10">
          <h1 className="font-display text-3xl font-semibold text-kelate-darkwood sm:text-4xl">Marketplace</h1>
          <p className="mt-1 text-sm text-kelate-soft">Everything Kelantan, delivered by KELATE. Pay when it arrives.</p>
        </div>
      </div>
      {deals.length > 0 && <Row title="Today's Deals" testId="mp-deals">{grid(deals)}</Row>}
      {best.length > 0 && <Row title="Best Selling" testId="mp-best">{grid(best)}</Row>}
      {fresh.length > 0 && <Row title="New Arrivals" testId="mp-new">{grid(fresh)}</Row>}
      {localPicks.length > 0 && <Row title="Made in Kelantan" testId="mp-local">{grid(localPicks)}</Row>}
      {featured.length > 0 && <Row title="Featured Products" testId="mp-featured">{grid(featured)}</Row>}
      {customMerchants.length > 0 && (
        <Row title="Stores" testId="mp-stores">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {[...customMerchants].sort((a, b) => (PLAN_RANK[a.plan] ?? 9) - (PLAN_RANK[b.plan] ?? 9)).map((m) => <StoreCard key={m.id} merchant={m} />)}
          </div>
        </Row>
      )}
    </div>
  );
}
